import LAYOUT from '@/layout/index.vue'
import { RouteRecordRaw } from 'vue-router'
import worldCup from './modules/world-cup'
import worldCupPlayerComment from './modules/world-cup-player-comment'
import womenWorldCupPlayerComment from './modules/women-world-cup-player-comment'
import wcbaThreePlayerComment from './modules/wcba-three-player-comment'
import wcbaThreeU23PlayerComment from './modules/wcba-three-u23-player-comment'
import olympic from '@/router/modules/olympic'
import foreignCoach from './modules/foreign-coach'
import talents from './modules/talents'
import talentPool from './modules/talent-pool'
const { outputDir } = require('/vue.config')
const loginRoutes: RouteRecordRaw[] = [
    {
        name: 'login',
        path: '/login',
        meta: {
            title: '登录',
        },
        component: () => import('@/view/login/index.vue'),
    },
]

export const layoutRoutes: RouteRecordRaw[] = [
    {
        name: 'layout',
        path: '/',
        redirect: outputDir == 'talent-pool' ? '/basketball-talent-pool' : '/home',
        meta: {
            title: '',
        },
        component: LAYOUT,
        children: [
            {
                name: 'home',
                path: 'home',
                meta: {
                    title: '首页',
                },
                component: () => import('@/view/home/index.vue'),
            },
        ],
    },
]

// 全部路由
//世界杯女子：womenWorldCupPlayerComment
//wcba球员三人篮球考察解析：wcbaThreePlayerComment
//k8首页：...layoutRoutes
export const baseRoutes: RouteRecordRaw[] = [
    ...loginRoutes,
    ...layoutRoutes,
    worldCup,
    worldCupPlayerComment,
    olympic,
    wcbaThreePlayerComment,
    wcbaThreeU23PlayerComment,
    womenWorldCupPlayerComment,
    foreignCoach,
    talents,
    // talentPoolHome,
    talentPool,
]
